import { atom } from "jotai";

import { commandPaletteAtom } from "./state";

export const highlightedIndexAtom = atom(
  (get) => get(commandPaletteAtom).highlightedIndex,
  (_get, set, value: number) => {
    set(commandPaletteAtom, (draft) => {
      draft.highlightedIndex = value;
    });
  },
);

export const moveHighlightAtom = atom(
  null,
  (get, set, { delta, count }: { delta: number; count: number }) => {
    if (count <= 0) {
      return;
    }

    const current = get(highlightedIndexAtom);
    const next = (current + delta + count) % count;

    set(highlightedIndexAtom, next);
  },
);
